import { render, staticRenderFns } from "./UnitCodeList.vue?vue&type=template&id=2a8c9ab2&"
import script from "./UnitCodeList.vue?vue&type=script&lang=js&"
export * from "./UnitCodeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports